import { render } from "./ProductoraForm.vue?vue&type=template&id=4096d7d0&scoped=true"
import script from "./ProductoraForm.vue?vue&type=script&lang=js"
export * from "./ProductoraForm.vue?vue&type=script&lang=js"

import "./ProductoraForm.vue?vue&type=style&index=0&id=4096d7d0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4096d7d0"]])

export default __exports__